import { render, staticRenderFns } from "./maptalks-tileset.vue?vue&type=template&id=0ccf3261&"
import script from "./maptalks-tileset.vue?vue&type=script&lang=js&"
export * from "./maptalks-tileset.vue?vue&type=script&lang=js&"
import style0 from "./maptalks-tileset.vue?vue&type=style&index=0&id=0ccf3261&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports